import { FC } from 'react';
import { ComponentMap, RichText } from '../content/rich-text';
const parse = (content: string) => {
  try {
    const parsedContent = JSON.parse(content);
    return parsedContent;
  } catch (error) {
    console.error('Error parsing content:', error);
    return null;
  }
};
const componentMap: Partial<ComponentMap> = {
  mention: (node: any, key: string) => {
    return <a key={key} href={node.resource === 'player' ? `/players/${node.playerId}` : `/teams/${node.teamId}`} className="text-navy-oxford underline">
        {node.resource === 'player' ? node.playerName : node.teamName}
      </a>;
  }
};
export const FeedEntryBody: FC<{
  richText?: string | null;
}> = ({
  richText
}) => {
  const richTextContent = richText ? parse(richText) : null;
  if (richTextContent) {
    return <RichText componentMap={componentMap} content={richTextContent} className="text-base @md:text-lg @lg:text-xl" />;
  }
  return null;
};